import styled from 'styled-components';
import { getThemeColor } from 'utils/styled';
import { InputAdornmentStyleProps } from './types';

export const InputAdornmentRoot = styled.div<InputAdornmentStyleProps>`
  align-items: center;
  color: ${(props) =>
    props.$validationState === 'invalid' && props.$position === 'start'
      ? getThemeColor('danger')
      : getThemeColor('d5')};
  display: flex;
  flex-shrink: 0;
  max-height: 18px;
  pointer-events: auto;
  width: auto;

  ${(props) => {
    if (props.$position === 'start') {
      return 'margin-right: 9px;';
    }
    return 'margin-left: 9px;';
  }}
`;
